import { env as webEnv } from '@micun/web-components'
import { ENV_CACHE } from '@micun/web-components/dist/utils'
import qs from 'qs'
export const bizDomain = ['micun.com', 'micun.cn']

export function isBizUrl(url: string = '') {
  if (!url) {
    return false
  }
  try {
    const urlObj = new URL(url)
    const { host } = urlObj
    const result = bizDomain.some((domain) => host.includes(domain))
    return result
  } catch (e: any) {
    console.error(e)
    return false
  }
}

export const isProd =
  process.env.REACT_APP_ENV === 'production' ||
  localStorage.getItem(ENV_CACHE) === 'prod'
export const isProdEnv = isProd && window.location.host.includes('micun.com')
export function getBaseOrigin(subdomain = 'api') {
  const suffix = isProd ? 'micun.com' : 'micun.cn'
  const fullSubdomain = window.location.host.split('.').slice(0, -2)
  let envDomain = ''
  if (!isProd) {
    envDomain = webEnv || (fullSubdomain.includes('beta') ? 'beta' : 'dev')
  }
  const host = [subdomain, envDomain, suffix].filter((s) => !!s).join('.')
  // const protocol = isProd ? 'https:' : 'http:'
  const protocol = window.location.protocol
  return `${protocol}//${host}`
}

export type TEnv = (string & {}) | 'beta' | 'dev' | 'prod'
export function getEnv(): TEnv {
  if (isProd) {
    return 'prod' as const
  } else {
    const fullSubdomain = window.location.host.split('.').slice(0, -2)
    const envDomain = webEnv || (fullSubdomain.includes('beta') ? 'beta' : 'dev')
    return envDomain
  }
}
export const env: TEnv = getEnv()

export const buildOrigin = (options: {
  subdomain?: string
  envDomain?: TEnv
}) => {
  const { subdomain = 'api', envDomain = env } = options
  const isProdEnv = envDomain === '' || envDomain === 'prod'
  const suffix = isProdEnv ? 'micun.com' : 'micun.cn'
  // const protocol = isProdEnv ? 'https:' : 'http:'
  const protocol = window.location.protocol
  const host = [subdomain, isProdEnv ? undefined : envDomain, suffix]
    .filter((s) => !!s)
    .join('.')
  return `${protocol}//${host}`
}

export const downloadFile = (url: string, query: object = {}) => {
  const win = window.open('', '_blank')
  let baseUrl = getBaseOrigin()
  let hasQuery = url.indexOf('?') !== -1
  if (!/^http/.test(url)) {
    if (url.startsWith('/')) {
      url = url.slice(1)
    }
    if (baseUrl.endsWith('/')) {
      baseUrl = baseUrl.slice(0, -1)
    }
  }
  if (win) {
    win.location.href = `${baseUrl}/${url}${hasQuery ? '&' : '?'}${qs.stringify(
      query,
      {
        allowDots: true,
        arrayFormat: 'repeat',
      }
    )}`
  }
}
